import {
  REPORTED_INCIDENTS_CLEAR,
  REPORTED_INCIDENTS_CLEAR_FILTERS,
  REPORTED_INCIDENTS_SET_DISCARD_REASON,
  REPORTED_INCIDENTS_SET_FORM,
  REPORTED_INCIDENTS_SET_ON_REVIEW,
} from '../../../../actions/actionTypes';

const defaultState = null;

const discardReason = (state = defaultState, action) => {
  const { type, payload } = action;
  switch (type) {
    case REPORTED_INCIDENTS_CLEAR:
    case REPORTED_INCIDENTS_CLEAR_FILTERS:
    case REPORTED_INCIDENTS_SET_FORM:
    case REPORTED_INCIDENTS_SET_ON_REVIEW:
      return defaultState;

    case REPORTED_INCIDENTS_SET_DISCARD_REASON:
      return payload?.discardReasonId;

    default:
      return state;
  }
};

export default discardReason;
